import styled from "styled-components";

import { ButtonBar } from "../buttons";

export const ModalButtonBar = styled(ButtonBar)`
  gap: 8px;
  padding: 24px;
`;
